import React from 'react';
import { useQuery } from 'react-query';
import NoData from '../common/no-data';
import Loadingcomponent from '../loader/loadingcomponent';
import TransactionCard from './transaction-card';

const TransactionHistory = ({ pmsitem }) => {
  const { data: { data } = {}, isLoading } = useQuery(
    [pmsitem.uniqueid, pmsitem.method, JSON.parse(pmsitem?.sourceid), {}],
    { retry: false }
  );

  if(isLoading){
    return <Loadingcomponent />
  }

  return (
    <div class="pse_lg">
      <div class="current-packs-comp">
        <div class="mt-4 mb-4">
          <h6>{data?.response?.title}</h6>
        </div>

        <div>
          {data?.response?.transhistory?.length > 0 ? (
            <>
              {data?.response?.transhistory?.map((trans) => {
                return (
                  <TransactionCard data={trans} icon={data?.response?.icon} />
                );
              })}
            </>
          ) : (
            <NoData />
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
